import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import '@deal/components';
import { usePathContext } from '../../../../context/PathContext.js';
import 'classnames';
import '../../../../generated/types.js';
import DefaultCard from '../../../SelectCard/PillCard/index.js';
import styles from './styles.css.js';

var SelectList = function SelectList(_ref) {
  var question = _ref.question,
      loading = _ref.loading,
      onQuestionUpdated = _ref.onQuestionUpdated,
      onQuestionValidityChanged = _ref.onQuestionValidityChanged;
  var pathContext = usePathContext();
  var listQuestion = question;
  var initialListChoices = listQuestion.choices.filter(function (choice) {
    return !!choice.selected;
  }).map(function (choice) {
    return choice.id;
  });

  var _useState = useState(initialListChoices),
      _useState2 = _slicedToArray(_useState, 2),
      selectedChoices = _useState2[0],
      updateSelectedChoices = _useState2[1];

  useEffect(function () {
    if (initialListChoices.length > 0) {
      populateListChoices(initialListChoices);
      onQuestionValidityChanged(true);
    }
  }, []);

  var handleChange = function handleChange(_ref2) {
    var choiceId = _ref2.choiceId,
        isChecked = _ref2.isChecked;
    var updatedChoices = [];

    if (!isChecked) {
      var filteredChoices = _toConsumableArray(selectedChoices).filter(function (choiceIdToRemove) {
        return choiceIdToRemove !== choiceId;
      });

      updatedChoices = filteredChoices;
    } else if (isChecked && !selectedChoices.includes(choiceId)) {
      updatedChoices = [].concat(_toConsumableArray(selectedChoices), [choiceId]);
    }

    updateSelectedChoices(updatedChoices);
    populateListChoices(updatedChoices);
  };

  var populateListChoices = function populateListChoices(updatedChoices) {
    var _a;

    onQuestionUpdated({
      id: (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id,
      listQuestion: {
        questionId: question.id,
        values: updatedChoices || []
      }
    });
    onQuestionValidityChanged(question.commonFields.required ? updatedChoices.length > 0 : true);
  };

  return React.createElement("div", {
    className: styles.pillContainer
  }, listQuestion.choices.map(function (choice) {
    return React.createElement(DefaultCard, {
      key: choice.id,
      disabled: loading,
      question: listQuestion,
      choice: choice,
      isSelected: selectedChoices.includes(choice.id),
      onHandleChange: handleChange
    });
  }));
};

export default SelectList;
//# sourceMappingURL=index.js.map
